<template>
  <div class="subpage main_area" style="position: relative">
    <div class="loading">
      
      <div class="detail_area">
        <div class="layout position-relative">
          <!--站内信-->
          <ul class="announce_list" id="zhanneixin" style="" v-if="activityApplyLogList.length>0">
            <li v-for="(item, index) in activityApplyLogList" :key="index">
              <div class="collapse">
                <div class="block_content"></div>
                <div class="block_content">
                  <div class="title">{{ item.activity_name }}</div>
                </div>
                <div class="block_content">
                  <div class="type">{{ item.created_at }}</div>
                </div>
                <div class="block_content">
                  <div class="type">{{ statuTypeS[item.state] }}</div>
                </div>
              </div>
            </li>
          </ul>
          <div data-v-77dd5443="" v-else class="no_data"><img data-v-77dd5443="" alt="" src="/static/image/img_emptybox.png" width="30%"> <div data-v-77dd5443="">暂无资料</div></div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'applyList',
  data() {
    return { activityApplyLogList: [], statuTypeS: ['0未约定', '待审核', '通过', '拒绝', '4未约定'] };
  },
  created() {
    let that = this;
    that.getactivityApplyLogList();
  },
  methods: {
    // 获取活动申请记录
    getactivityApplyLogList() {
      let that = this;
      that.$parent.showLoading();
      let info = {
        limit: 99999,
        page: 1,
      };
      that.$apiFun.post('/api/activityApplyLog', {}).then(res => {
        console.log(res);
        if (res.code != 200) {
          that.$parent.showTost(0, res.message);
        }
        if (res.code == 200) {
          that.activityApplyLogList = res.data.data;
        }
        that.$parent.hideLoading();
      });
    },
  },
  mounted() {
    let that = this;
  },
  updated() {
    let that = this;
  },
  beforeDestroy() {},
};
</script>
<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// src/components/mode/applyList.vue